import React, { useContext, } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getIntroStyles } from './styles';

export function IntroTexts(props) {
  const {
    introTitle,
    introTexts,
    displayMode,
  } = props;

  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getIntroStyles);

  return (
    <div className={classNames('intro-container', classes.introContainer, classes[`introContainer-${displayMode}`])}>
      <div className="intro-title">
        {i18n.getString(introTitle)}
      </div>
      <div className="intro-body">
        <ul>
          {introTexts.map(text => (<li>{i18n.getString(text)}</li>))}
        </ul>
      </div>
    </div>
  );
}

IntroTexts.propTypes = {
  introTitle: PropTypes.string.isRequired,
  introTexts: PropTypes.arrayOf(PropTypes.string).isRequired,
  displayMode: PropTypes.string,
};

IntroTexts.defaultProps = {
  displayMode: '',
};
